import { ClientProducts } from '@/api/types/products/client-types';
import { ProductCard } from '../product-card/product-card';
import { SubcategoryProducts } from '../subcategory-products/subcategory-products';
import { GridLayout } from '../grid-layout/grid-layout';

import styles from './category-products.module.css';
import { getCategoryDataTestid } from '@/utils/navigate-to-products';
import { useInfo } from '@/app/infoContext';

export const CategoryProducts = ({
  products,
  isAvailable,
  withTitle = true,
}: {
  products: ClientProducts;
  isAvailable?: boolean;
  withTitle?: boolean;
}) => {
  const { isMobile } = useInfo();


  const Content = () => {
    if ('products' in products) {
      return (
        <GridLayout display={isMobile ? 'flex' : 'grid'}>
          {products.products.map((product) => (
            <ProductCard key={product.id} product={product} isAvailable={isAvailable} />
          ))}
        </GridLayout>
      );
    }
    if ('subcategories' in products) {
      return (
        <div>
          {products.subcategories.map((subcategory) => (
            <SubcategoryProducts isAvailable={isAvailable} subcategory={subcategory} key={subcategory.id} />
          ))}
        </div>
      );
    }
  };

  return (
    <div
      className={`${styles.wrapper} ${isMobile ? styles.isMobile : ''}`}
      data-testid={getCategoryDataTestid(products.id)}
      aria-label={products.categoryName}
    >
      {withTitle && <h3 className={styles.title}>{products.categoryName}</h3>}
      <Content />
    </div>
  );
};
